import { render } from "./EditModeButtons.vue?vue&type=template&id=cc8b9b56&ts=true"
import script from "./EditModeButtons.vue?vue&type=script&lang=ts"
export * from "./EditModeButtons.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3662402436/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__